export default __webpack_public_path__ + "static/media/furniture1.b152772c.jpeg";